import { getDefaultAttributes, trackEvent } from 'core-lib/utils/events';

export const getPage = () => {
  const path = window.location.pathname.split('/');
  const page = path[path.length - 1];
  var param = window.location.search;
  if (page === 'parkplus-store' && param.search('active_tab=1') !== -1)
    return 'homepage_tab_2';
  if (page === 'parkplus-store') return 'homepage_tab_1';
  else if (page === 'product-listing') return 'PLP';
  else if (page === 'search') return 'Store Search Page';
  else if (page === 'cart') return 'cart';
  else if (page === 'category') return 'CLP';
  else if (page === 'instant-petrol') return 'instant_petrol';
  else return +page > 0 ? 'PDP' : 'CLP';
};

const getProudctId = () => window?.location?.pathname?.split('/')?.pop();

export const trackIconClickedStoreV2 = (option: string) => {
  trackEvent({
    name: 'icon_clicked',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: getPage(),
      option_selected: option,
      category: 'store',
    },
  });
};

export const trackCardClickedStoreV2 = (
  section: string = '',
  option: number | string,
  id?: number | string,
  position?: string,
  additionalAttributes?: any
) => {
  trackEvent({
    name: 'card_clicked',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: getPage(),
      section: section,
      option_selected: option,
      product_id: id,
      position: position,
      category: 'store',
      ...additionalAttributes,
    },
  });
};

export const trackCardViewedStoreV2 = ({
  section,
  pageName = getPage(),
  additionalAttributes = {},
}: {
  section?: string;
  pageName?: string;
  category?: any;
  additionalAttributes?: any;
}) => {
  trackEvent({
    name: 'card_viewed',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: pageName,
      section: section,
      category: 'store',
      ...additionalAttributes,
    },
  });
};

export const trackPageLoadStoreV2 = (
  option?: string,
  additionalAttributes = {}
) => {
  additionalAttributes = JSON.parse(JSON.stringify(additionalAttributes)) ?? {};
  trackEvent({
    name: 'page_loaded',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: getPage(),
      option_selected: option,
      category: 'store',
      ...additionalAttributes,
    },
  });
};

export const trackCtaClickedStoreV2 = (
  section?: string,
  option?: string | number,
  additionalAttributes?: any
) => {
  trackEvent({
    name: 'cta_clicked',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: getPage(),
      section,
      option_selected: option,
      category: 'store',
      ...additionalAttributes,
      ...(getPage() === 'PDP' && { product_id: getProudctId() }),
    },
  });
};

export const trackPopupViewStoreV2 = (name: string) => {
  trackEvent({
    name: 'popup_viewed',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: getPage(),
      popup_name: name,
      category: 'store',
    },
  });
};

export const trackSectionViewedStoreV2 = (
  section?: string,
  additionalAttributes?: any
) => {
  trackEvent({
    name: 'section_viewed',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: getPage(),
      section: section,
      category: 'store',
      ...additionalAttributes,
    },
  });
};

export const trackSearchClicked = () => {
  trackEvent({
    name: 'search_clicked',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      category: 'Store',
      page_name: getPage(),
    },
  });
};

export const trackSearchSubmitted = (keyword: string, type: string) => {
  trackEvent({
    name: 'search_submitted',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      category: 'Store',
      page_name: getPage(),
      search_type: type,
      keyword,
    },
  });
};

export const trackNoSearchResult = (keyword: string) => {
  trackEvent({
    name: 'no_search_results',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      category: 'Store',
      page_name: getPage(),
      keyword,
    },
  });
};

export const trackSlideChange = (
  currentSlide: number,
  additionalAttributes?: any
) => {
  trackEvent({
    name: 'slide_change',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      category: 'Store',
      page_name: getPage(),
      current_slide: currentSlide,
      product_id: getProudctId(),
      ...additionalAttributes,
    },
  });
};
export const trackSuggestProductClicked = () => {
  trackEvent({
    name: 'suggest_product_clicked',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      category: 'Store',
      page_name: getPage(),
    },
  });
};

export const trackSuggestProductSubmitted = (keyword: string) => {
  trackEvent({
    name: 'suggest_product_submitted',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      category: 'Store',
      page_name: getPage(),
      keyword,
    },
  });
};

export const trackProductViewedStoreV2 = (
  section?: string,
  id?: number,
  additionalAttributes?: any
) => {
  trackEvent({
    name: 'product_viewed',
    defaultAttr: getDefaultAttributes(),
    attributes: {
      page_name: getPage(),
      section: section,
      product_id: id,
      category: 'store',
      ...additionalAttributes,
    },
  });
};
